export default __webpack_public_path__ + "static/media/error-500.5d41c8ef.jpg";